import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Col, Row} from 'antd';

import DocumentHead from '../../../elements/components/DocumentHead';
import scrollToTop from '../../../elements/lib/scrollToTop';
import Logger from '../../../../../lib/Logger';

class SurveyContent extends Component {

  render() {
    return (
      <Translation>{(t) => 
        <>

          <DocumentHead title={t('content_route_survey')} />

          <Row>
            <Col span={24}>

              <iframe src="https://www.cognitoforms.com/f/RnQXxvDs4Uyff6Y8NCacyg?id=25" frameBorder="0" scrolling="yes" seamless="seamless" height="4191" width="100%" title="Survey"></iframe>

            </Col>
          </Row>

        </>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    scrollToTop();

    const script = document.createElement("script");
    script.src = "https://www.cognitoforms.com/scripts/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }
}

export default SurveyContent;

Logger.log('silly', `SurveyContent loaded.`);
